module.exports = __webpack_public_path__ + "img/FR-Wix-integration-vidjet-step2.7b17108d.png";